<div class="image-cropper">
    <dp-icon-svg *ngIf="loading && !loadFailed" name="loading-spinner" class="image-cropper__icon"></dp-icon-svg>

    <div class="image-cropper__error" *ngIf="loadFailed && !loading">
        <dp-icon-svg name="error"></dp-icon-svg>
        <small class="mt-1">Ops, algo deu errado.<br />
            Verifique o formato e tente de novo.</small
        >
    </div>

    <dp-icon-svg *ngIf="!imageChangedEvent && !loading && !loadFailed" [name]="classIcon" class="image-cropper__icon"></dp-icon-svg>
    <!-- <dp-icon-svg [name]="classIcon" class="image-cropper__icon"></dp-icon-svg> -->

    <div class="image-cropper__description-icon">
        <ng-content ></ng-content>
    </div>

    <div class="image-cropper__controls" *ngIf="controls && imageChangedEvent && !loading && !loadFailed">
    <!-- <div class="image-cropper__controls"> -->
        <i class="fa fa-times" (click)="onRemove(imageChangedEvent)" title="Girar verticalmente" aria-hidden="true"></i>
        <i class="fa fa-arrows-v" (click)="flipVertical()" title="Girar verticalmente" aria-hidden="true"></i>
        <i class="fa fa-arrows-h" (click)="flipHorizontal()" title="Girar horizontalmente" aria-hidden="true"></i>

        <i class="fa fa-rotate-left" (click)="rotateLeft()" title="Girar à esquerda" aria-hidden="true"></i>
        <i class="fa fa-rotate-right" (click)="rotateRight()" title="Girar à direita" aria-hidden="true"></i>
    </div>

    <image-cropper
        [hidden]="!loading"
        #cropperElem
        class="m-auto"
        [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="false"
        (imageCropped)="imageCropped($event)"
        (cropperReady)="isReadyToCropp()"
        (loadImageFailed)="loadImageFailed()"
        (imageLoaded)="imageLoaded()"
        [onlyScaleDown]="true"
        [cropper]="cropperPosition"
        [autoCrop]="autoCrop"
        [resizeToWidth]="1024"
        [style.max-height]="'175px'"
        [style.display]="imgLoaded ? null : 'none'"
    >
    </image-cropper>

    <div *ngIf="!loading">
        <dp-button
            [variant]="imageChangedEvent && !loadFailed ? 'link' : 'outline-secondary'"
            [full]="true"
            [class.btn-edit]="imageChangedEvent && !loadFailed"
        >
            <i *ngIf="imageChangedEvent && !loadFailed" class="fa fa-pencil-square-o"></i>

            {{ !imageChangedEvent || loadFailed ? btnName : 'Editar imagem' }}

            <input spellcheck="false"type="file" (change)="fileChangeEvent($event)" [disabled]="loading" accept=".png, .jpg, .jpeg, .webp, .bmp" />
        </dp-button>
    </div>
</div>
